import { render, staticRenderFns } from "./buttonTemplate.vue?vue&type=template&id=6f92d563&scoped=true"
import script from "./buttonTemplate.vue?vue&type=script&lang=ts"
export * from "./buttonTemplate.vue?vue&type=script&lang=ts"
import style0 from "./buttonTemplate.vue?vue&type=style&index=0&id=6f92d563&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f92d563",
  null
  
)

export default component.exports